import React from "react";
import url from "url";
export const aLink = React.forwardRef(({
  href,
  children,
  replace: _replace,
  shallow: _shallow,
  prefetch: _prefetch,
  ...rest
}, ref) => {
  const hrefAsString = typeof href !== "string" ? url.format(href) : href;
  return /*#__PURE__*/React.createElement("a", {
    ref: ref,
    href: hrefAsString,
    ...rest
  }, children);
});
export const noHrefLink = React.forwardRef(({
  className,
  "aria-current": ariaCurrent,
  "aria-label": ariaLabel,
  onClick,
  children
}, ref) => /*#__PURE__*/React.createElement("a", {
  ref: ref,
  className: className,
  "aria-current": ariaCurrent,
  "aria-label": ariaLabel,
  onClick: onClick
}, children));
export const SparkleContext = React.createContext({
  components: {
    link: aLink
  }
});
//# sourceMappingURL=context.js.map